export default function PageBanner({ title, en, variant = "about" }) {
  return (
    <section className={`page-banner banner-${variant}`}>
      <div className="banner-shade" />
      <div className="container page-banner-inner">
        <p className="eyebrow">{en}</p>
        <h1>{title}</h1>
      </div>
    </section>
  );
}
